import { noop } from "@common/helpers/function";
import { createContext, useContext } from "react";
import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";

export interface EntityLogoUploadContextValue {
    isDragActive: boolean;
    inputProps: DropzoneInputProps;
    rootProps: DropzoneRootProps;
    isUploading: boolean;
    open(): void;
}

export const entityLogoUploadContext =
    createContext<EntityLogoUploadContextValue>({
        isDragActive: false,
        inputProps: {},
        rootProps: {},
        isUploading: false,
        open: noop,
    });

export const useEntityLogoUpload = () => {
    const context = useContext(entityLogoUploadContext);

    if (!context) {
        throw new Error(
            "useEntityLogoUpload must be used within an EntityLogoUploadProvider",
        );
    }

    return context;
};
